import { useEffect, useState } from "react"
import classNames from "./styles.module.scss"
import { Layer, BaseLayer } from "./../../../shared/StoreContainer/type"

import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './../../../shared/StoreContainer/actionCreators';

export const LayersFilter = (props: {
  map: JSX.Element
}) => {
  const dispatch: Dispatch<any> = useDispatch();

  const [top, setTop] = useState<number>(0)
  const [left, setLeft] = useState<number>(0)

  //@ts-ignore
  const layersContainer = useSelector((state) => (state?.containerLayers));
  //@ts-ignore
  const baseLayersContainer = useSelector((state) => (state?.containerBaseLayers));
  //@ts-ignore
  const filtersActiveContainer = useSelector((state) => (state?.containerFilterActive));

  useEffect(() => {
    let icon = document.getElementById('FilterIcon')
    if (icon) {
      icon.offsetTop && setTop(icon.offsetTop)
      icon.offsetLeft && setLeft(icon.offsetLeft + 18)
    }
  }, [filtersActiveContainer])

  let layers: Array<Layer> = layersContainer && layersContainer.layers;
  let baseLayers: Array<BaseLayer> = baseLayersContainer && baseLayersContainer.baseLayers;

  return <>
    {filtersActiveContainer.active && layers && baseLayers && top > 0 && left > 0 &&
      <>
        <div id='filters' style={{ top: top + 50 + 'px' }} className={classNames.filters}>
          <div className={classNames.filtersLine}>
            {baseLayers.map((baseLayer, i) => (
              <p
                key={i + 'button'}
                onClick={() => {
                  const newLayersState = [...(baseLayers || [])];
                  newLayersState.forEach((baseLayer2, i2) => {
                    if (i === i2) baseLayer2.turned = !baseLayer.turned
                    else baseLayer2.turned = false
                  })
                  dispatch(actions.setBaseLayers(newLayersState));
                }}
                className={classNames.filtersButton + ' ' + (baseLayer.turned ? classNames.active : '')}>{baseLayer.label}</p>
            ))}
          </div>
          <div className={classNames.filtersLine}>
            {layers.map((layer, i) => (
              <p
                key={i + 'button'}
                onClick={() => {
                  const newLayersState = [...(layers || [])];
                  newLayersState.forEach((layer2, i2) => {
                    if (i === i2) layer2.turned = !layer.turned
                    else layer2.turned = false
                  })
                  dispatch(actions.setLayers(newLayersState));
                }}
                className={classNames.filtersButton + ' ' + (layer.turned ? classNames.active : '')}>{layer.label}</p>
            ))}
          </div>
        </div>
        <div style={{ top: top + 15 + 'px', left: left + 'px' }} className={classNames.triangle} />
      </>}
  </>
}